import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"

import {
    removeAuthToken,
    setLoggedUser,
    setUserRole,
    logoutUser
} from "../../redux/actions"


export default function LogoutPage() {
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('role');
        localStorage.removeItem('user');
        dispatch(logoutUser());
        dispatch(setUserRole(0))
        dispatch(removeAuthToken());
        dispatch(setLoggedUser(null));

        setTimeout(() => {
            history.replace('/')
        }, 500);

    }, [])
    return (
        <div className="mt-2 ml-2">
            Waiting....
        </div>
    )
}
